import LocalStorageCache from './lib/LocalStorageCache.js';
import MemoryCache from './lib/MemoryCache.js';
/**
 * @classdesc
 * Using multiple sources of potential specification, provide interface
 * for querying the flag status and updating preferences.
 */
class FeatureFlagManager {
    constructor(preferences, session) {
        this.preferences = preferences;
        this.session = session;
    }
    /**
     * Environment is a "master" control. When false, no other priority is acknowledged.
     * The order of priority is: Session > Preference > Default.
     * Session is best used for testing, while preferences are best for
     * persistenting access.
     * @param {string} featureID
     * @return {boolean}
     */
    hasFeatureEnabled(featureID, featureDefault = false) {
        var _a;
        const featureEnvironment = this.getFeatureEnvironment(featureID);
        const featureSession = this.getFeatureSession(featureID);
        const featurePreference = this.getFeaturePreference(featureID);
        if (!featureEnvironment)
            return false;
        const featureEnabled = (_a = featureSession !== null && featureSession !== void 0 ? featureSession : featurePreference) !== null && _a !== void 0 ? _a : featureDefault;
        return ((typeof featureEnabled === 'string')
            ? JSON.parse(featureEnabled)
            : !!featureEnabled);
    }
    /**
     * @param {string} featureID
     * @return {boolean}
     */
    getFeatureEnvironment(featureID) {
        return FeatureFlagManager.environment.get(featureID) === true;
    }
    /**
     * @param {string} featureID
     * @return {boolean | null}
     */
    getFeaturePreference(featureID) {
        if (!this.preferences.has(featureID))
            return null;
        return this.preferences.get(featureID);
    }
    /**
     * @param {string} featureID
     * @return {boolean | null}
     */
    getFeatureSession(featureID) {
        if (!this.session.has(featureID))
            return null;
        return this.session.get(featureID);
    }
    /**
     * @param {string} featureID
     * @param {boolean} flag
     * @return {Promise<this>}
     */
    async setFeaturePreference(featureID, flag) {
        return (this.preferences.set(featureID, flag)
            .then(() => this));
    }
    /**
     */
    static configure(environment) {
        [...Object.entries(environment)].forEach(([key, value]) => this.environment.set(key, value));
    }
}
/**
 */
FeatureFlagManager.LocalStorageCache = LocalStorageCache;
/**
 */
FeatureFlagManager.MemoryCache = MemoryCache;
/**
 */
FeatureFlagManager.environment = new MemoryCache();
export default FeatureFlagManager;
